/* Tudo Brasil - escalera de precios por cantidad (bloque tb-precios-cantidad).

   La tabla ya viene dibujada desde Liquid, asi que sin JS igual se lee: esto
   solo resalta el tramo que corresponde a la cantidad elegida y arma el
   resumen. Lee el input de cantidad de la ficha, no el de las cards: se acota
   con .product-information, que envuelve solo el bloque principal del producto.

   El resumen sale partido en dos spans a proposito: el detalle va en liviana y
   el total en negrita, que es el numero por el que decide el comprador.

   OJO: los precios de los tramos son informativos hasta que este publicada la
   funcion de descuento. */
(() => {
  if (customElements.get('tb-precios-cantidad')) return;

  const moneda = (centavos) =>
    '$' +
    (centavos / 100).toLocaleString('es-UY', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  customElements.define(
    'tb-precios-cantidad',
    class extends HTMLElement {
      connectedCallback() {
        this.filas = Array.from(this.querySelectorAll('.tb-tp__fila'));
        this.resumen = this.querySelector('.tb-tp__resumen');
        if (!this.filas.length || !this.resumen) return;

        const ficha = this.closest('.product-information') || document;
        this.input = ficha.querySelector('.product-form-buttons input[name="quantity"]');

        this.alCambiar = () => this.actualizar();
        if (this.input) {
          this.input.addEventListener('input', this.alCambiar);
          this.input.addEventListener('change', this.alCambiar);
          // los botones + y - escriben el valor por JS y no siempre disparan
          // input, asi que tambien se escucha el click en el selector
          this.selector = this.input.closest('.quantity-selector');
          if (this.selector) this.selector.addEventListener('click', () => setTimeout(this.alCambiar, 0));
        }

        this.actualizar();
      }

      disconnectedCallback() {
        if (!this.input || !this.alCambiar) return;
        this.input.removeEventListener('input', this.alCambiar);
        this.input.removeEventListener('change', this.alCambiar);
      }

      actualizar() {
        const cantidad = Math.max(1, parseInt((this.input && this.input.value) || '1', 10) || 1);

        let activa = this.filas[0];
        for (const fila of this.filas) {
          if (cantidad >= Number(fila.dataset.desde)) activa = fila;
        }
        for (const fila of this.filas) {
          fila.classList.toggle('tb-tp__fila--activa', fila === activa);
        }

        const unitario = Number(activa.dataset.unitario);

        const detalle = document.createElement('span');
        detalle.className = 'tb-tp__resumen-detalle';
        detalle.textContent =
          cantidad === 1
            ? 'Llevando 1 unidad: ' + moneda(unitario) + ' cada una.'
            : 'Llevando ' + cantidad + ' unidades: ' + moneda(unitario) + ' cada una';

        this.resumen.replaceChildren(detalle);

        if (cantidad > 1) {
          const total = document.createElement('span');
          total.className = 'tb-tp__resumen-total';
          total.textContent = ' · ' + moneda(unitario * cantidad) + ' en total.';
          this.resumen.append(total);
        }

        this.resumen.hidden = false;
      }
    }
  );
})();
